/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// //import '../../css/event210621.css'

// import "../../css/event220617.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";

import QuestItem from "../../components/event/QuestItem";

class Event202210_quest extends PureComponent {
  state = {
    success: false,
  };
  componentDidMount = () => {};

  _close = () => {
    const { close } = this.props.childProps;
    close();
  };
  _onSolution = (contentSerial, snum) => {
    // const { loginId } = this.props;
    const { onSolution } = this.props.childProps;
    //정답 확인할 것....api url event_202210_solution
    console.log(contentSerial, snum);
    onSolution(contentSerial, snum);
    //onCloseQuest()
  };
  _renderItem = () => {
    const { qlist, contentSerial } = this.props.childProps;

    const list = qlist.map((item, index) => {
      return (
        <QuestItem
          key={index}
          snum={item.snum}
          title={item.title}
          contentSerial={contentSerial}
          onSolution={this._onSolution}
        />
      );
    });

    return list;
  };

  render() {
    const { qlist } = this.props.childProps;
    return (
      <Fragment>
        {qlist ? (
          <div className="pop_quiz">
            <ul className="popContainer">
              <li className="quiz">
                <div className="q">
                  <p>Q.</p>
                  {qlist[0].quest}
                </div>
                <div className="answer" style={{ width: "100%" }}>
                  {this._renderItem()}
                </div>
              </li>
            </ul>
            <img src="/img/event/event220916/pop_bg_quiz.png" />
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202210_quest));
